<template>
    <div class="row">
        <div class="col">
            <div class="mb-1 d-block">
                <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" name="type" id="bulan" v-model="type" value="bulan">
                    <label class="form-check-label" for="bulan">Bulan</label>
                </div>
                <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" name="type" id="tarikh" v-model="type" value="tarikh">
                    <label class="form-check-label" for="tarikh">Tarikh</label>
                </div>
            </div>
            <div class="d-inline-block">
                <div class="d-flex mb-3" v-if="type ==='tarikh'">
                <VueDatePicker v-model="dateFrom" :auto-position="true"
                               :time-config="{ enableTimePicker: false }" :formats="{ input: 'dd-MMM-yyyy', preview: 'dd-MMM-yyyy' }" week-start="0" :locale="ms" :format-locale="ms"
                               placeholder="Tarikh mula" select-text="Pilih" cancel-text="Tutup" required class="d-inline-block me-2" style="max-width: 250px"></VueDatePicker>
                <span class="d-inline-block me-2 my-1">hingga</span>
                <VueDatePicker v-model="dateTo" :auto-position="true"
                               :time-config="{ enableTimePicker: false }" :formats="{ input: 'dd-MMM-yyyy', preview: 'dd-MMM-yyyy' }" week-start="0" :locale="ms" :format-locale="ms"
                               placeholder="Tarikh akhir" select-text="Pilih" cancel-text="Tutup" required class="d-inline-block" style="max-width: 250px"></VueDatePicker>
                </div>
            </div>
            <div class="d-inline-block mb-3" v-if="type ==='bulan'">
                <select class="form-select d-inline-block" style="width: 100px" v-model="monthSelected">
                    <option v-for="m in monthRange" :value="m" class="text-center">{{ m }}</option>
                </select>
                <select class="form-select d-inline-block" style="width: 100px" v-model="yearSelected">
                    <option v-for="y in yearRange" :value="y" class="text-center">{{ y }}</option>
                </select>
            </div>
            <button :disabled="(dateFrom ===  null && dateTo === null) && type === 'tarikh'" type="button" class="btn btn-primary ms-2" @click="getData()"><font-awesome-icon :icon="faMagnifyingGlass" class="me-2"/>Cari
            </button>
            <div class="form-check form-check-inline ms-2">
                <input class="form-check-input" type="checkbox" id="pejabatLama" value="old" v-model="olderOffice">
                <label class="form-check-label" for="pejabatLama">Pejabat lama</label>
            </div>
            <form v-if="reportData.projekWakafKaunter.length > 0" :action="uri_download_report_projekwakaf_kaunter" method="post" class="d-inline-block">
                <input type="hidden" name="_token" :value="csrf">
                <input type="hidden" v-if="olderOffice !== undefined" name="wantOld" :value="(olderOffice)?1:0">
                <input type="hidden" v-if="type === 'bulan'" name="month" :value="monthSelected">
                <input type="hidden" v-if="type === 'bulan'" name="year" :value="yearSelected">
                <input type="hidden" v-if="type === 'tarikh' && dateFrom !== null" name="from" :value="parseDateData(dateFrom)">
                <input type="hidden" v-if="type === 'tarikh' && dateTo !== null" name="to" :value="parseDateData(dateTo)">
                <button type="submit" :disabled="(dateFrom ===  null && dateTo === null) && type === 'tarikh'" class="btn btn-outline-success fs-6 d-inline-block" ><font-awesome-icon :icon="faFileExcel" class="me-2" />Muat turun laporan</button>
            </form>
            <button type="button" class="btn btn-warning ms-2 float-end"
                    @click="goBack">
                <font-awesome-icon :icon="faChevronLeft" /> Kembali
            </button>
        </div>
    </div>
    <div class="row">
        <div class="col-md-12">
            <div class="wrapper" ref="wrapper">
                <table v-if="reportData.projekWakafKaunter.length > 1"  id="projekWakafKaunter" class="table table-striped-columns">
                    <thead class="table-dark">
                    <tr>
                        <th class="text-center align-middle" style="width: 5px;" rowspan="3">Bil</th>
                        <th class="text-center align-middle" rowspan="3">Projek Wakaf</th>
                        <th class="text-center" :colspan="reportData.offices.length*2">Kaunter</th>
                        <th class="text-center align-middle" colspan="2" rowspan="2">Jumlah</th>
                    </tr>
                    <tr>
                        <th colspan="2" v-for="office in reportData.offices" class="text-center position-sticky text-break" style="border: 1px solid black; top: 0">{{ office }}</th>
                    </tr>
                    <tr>
                        <template v-for="n in reportData.offices.length" :key="n">
                            <th class="text-center position-sticky" style="border: 1px solid black;" :style="{ 'top': offsetHeight + 'px' }">Bil</th>
                            <th class="text-center position-sticky" style="border: 1px solid black;" :style="{ 'top': offsetHeight + 'px' }">Amaun</th>
                        </template>
                        <th class="text-center position-sticky" style="border: 1px solid black;" :style="{ 'top': offsetHeight + 'px' }">Bil</th>
                        <th class="text-center position-sticky" style="border: 1px solid black;" :style="{ 'top': offsetHeight + 'px' }">Amaun</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(item,index) in reportData.projekWakafKaunter">
                        <td class="text-white fw-bold">{{ index+1}}</td>
                        <td class="text-white fw-bold">{{ item.project  }}</td>
                        <td class="text-end">{{ sumFormatWithoutDecimal(item.IbuPejabatBil) }}</td>
                        <td class="text-end">{{ sumFormatWithoutCurrency(item.IbuPejabatAmaun)  }}</td>
                        <td class="text-end">{{ sumFormatWithoutDecimal(item.KuantanBil)  }}</td>
                        <td class="text-end">{{ sumFormatWithoutCurrency(item.KuantanAmaun)  }}</td>
                        <td class="text-end">{{ sumFormatWithoutDecimal(item.TemerlohBil)  }}</td>
                        <td class="text-end">{{ sumFormatWithoutCurrency(item.TemerlohAmaun)  }}</td>
                        <td class="text-end">{{ sumFormatWithoutDecimal(item.RaubBil)  }}</td>
                        <td class="text-end">{{ sumFormatWithoutCurrency(item.RaubAmaun)  }}</td>
                        <td class="text-end">{{ sumFormatWithoutDecimal(item.PekanBil)  }}</td>
                        <td class="text-end">{{ sumFormatWithoutCurrency(item.PekanAmaun)  }}</td>
                        <td class="text-end">{{ sumFormatWithoutDecimal(item.RompinBil)  }}</td>
                        <td class="text-end">{{ sumFormatWithoutCurrency(item.RompinAmaun)  }}</td>
                        <td class="text-end">{{ sumFormatWithoutDecimal(item.JengkaBil)  }}</td>
                        <td class="text-end">{{ sumFormatWithoutCurrency(item.JengkaAmaun)  }}</td>
                        <td class="text-end">{{ sumFormatWithoutDecimal(item.JerantutBil)  }}</td>
                        <td class="text-end">{{ sumFormatWithoutCurrency(item.JerantutAmaun)  }}</td>
                        <td class="text-end">{{ sumFormatWithoutDecimal(item.BentongBil)  }}</td>
                        <td class="text-end">{{ sumFormatWithoutCurrency(item.BentongAmaun)  }}</td>
                        <td class="text-end">{{ sumFormatWithoutDecimal(item.KualaLipisBil)  }}</td>
                        <td class="text-end">{{ sumFormatWithoutCurrency(item.KualaLipisAmaun)  }}</td>
                        <td class="text-end">{{ sumFormatWithoutDecimal(item.MuadzamShahBil)  }}</td>
                        <td class="text-end">{{ sumFormatWithoutCurrency(item.MuadzamShahAmaun) }}</td>
                        <td class="text-end">{{ sumFormatWithoutDecimal(item.BeraBil)  }}</td>
                        <td class="text-end">{{ sumFormatWithoutCurrency(item.BeraAmaun)  }}</td>
                        <td class="text-end">{{ sumFormatWithoutDecimal(item.MaranBil)  }}</td>
                        <td class="text-end">{{ sumFormatWithoutCurrency(item.MaranAmaun)  }}</td>
                        <td class="text-end">{{ sumFormatWithoutDecimal(item.InderaMahkotaBil)  }}</td>
                        <td class="text-end">{{ sumFormatWithoutCurrency(item.InderaMahkotaAmaun)  }}</td>
                        <td class="text-end">{{ sumFormatWithoutDecimal(item.UnitKtrBergerak1Bil)  }}</td>
                        <td class="text-end">{{ sumFormatWithoutCurrency(item.UnitKtrBergerak1Amaun)  }}</td>
                        <td class="text-end">{{ sumFormatWithoutDecimal(item.UnitKtrBergerak2Bil)  }}</td>
                        <td class="text-end">{{ sumFormatWithoutCurrency(item.UnitKtrBergerak2Amaun)  }}</td>
                        <td class="text-end">{{ sumFormatWithoutDecimal(item.UtcKuantanBil)  }}</td>
                        <td class="text-end">{{ sumFormatWithoutCurrency(item.UtcKuantanAmaun)  }}</td>
                        <template v-if="reportData.offices.length > 27">
                            <td class="text-end">{{ sumFormatWithoutDecimal(item.IbuPejabatWakafBil ??  0)  }}</td>
                            <td class="text-end">{{ sumFormatWithoutCurrency(item.IbuPejabatWakafAmaun ??  0)  }}</td>
                            <td class="text-end">{{ sumFormatWithoutCurrency(item.KaunterWakafBentongBil ??  0) }}</td>
                            <td class="text-end">{{ sumFormatWithoutCurrency(item.KaunterWakafBentongAmaun ??  0) }}</td>
                            <td class="text-end">{{ sumFormatWithoutCurrency(item.KaunterWakafBeraBil ??  0) }}</td>
                            <td class="text-end">{{ sumFormatWithoutCurrency(item.KaunterWakafBeraAmaun ??  0) }}</td>
                            <td class="text-end">{{ sumFormatWithoutCurrency(item.KaunterWakafCameronHighlandsBil ??  0) }}</td>
                            <td class="text-end">{{ sumFormatWithoutCurrency(item.KaunterWakafCameronHighlandsAmaun ??  0) }}</td>
                            <td class="text-end">{{ sumFormatWithoutCurrency(item.KaunterWakafChenorBil ??  0) }}</td>
                            <td class="text-end">{{ sumFormatWithoutCurrency(item.KaunterWakafChenorAmaun ??  0) }}</td>
                            <td class="text-end">{{ sumFormatWithoutCurrency(item.KaunterWakafJengkaBil ??  0) }}</td>
                            <td class="text-end">{{ sumFormatWithoutCurrency(item.KaunterWakafJengkaAmaun ??  0) }}</td>
                            <td class="text-end">{{ sumFormatWithoutCurrency(item.KaunterWakafJerantutBil ??  0) }}</td>
                            <td class="text-end">{{ sumFormatWithoutCurrency(item.KaunterWakafJerantutAmaun ??  0) }}</td>
                            <td class="text-end">{{ sumFormatWithoutCurrency(item.KaunterWakafKompleksAsnafBil ??  0) }}</td>
                            <td class="text-end">{{ sumFormatWithoutCurrency(item.KaunterWakafKompleksAsnafAmaun ??  0) }}</td>
                            <td class="text-end">{{ sumFormatWithoutCurrency(item.KaunterWakafKuantanBil ??  0) }}</td>
                            <td class="text-end">{{ sumFormatWithoutCurrency(item.KaunterWakafKuantanAmaun ??  0) }}</td>
                            <td class="text-end">{{ sumFormatWithoutCurrency(item.KaunterWakafLipisBil ??  0) }}</td>
                            <td class="text-end">{{ sumFormatWithoutCurrency(item.KaunterWakafLipisAmaun ??  0) }}</td>
                            <td class="text-end">{{ sumFormatWithoutCurrency(item.KaunterWakafMaranBil ??  0) }}</td>
                            <td class="text-end">{{ sumFormatWithoutCurrency(item.KaunterWakafMaranAmaun ??  0) }}</td>
                            <td class="text-end">{{ sumFormatWithoutCurrency(item.KaunterWakafMuadzamBil ??  0) }}</td>
                            <td class="text-end">{{ sumFormatWithoutCurrency(item.KaunterWakafMuadzamAmaun ??  0) }}</td>
                            <td class="text-end">{{ sumFormatWithoutCurrency(item.KaunterWakafPekanBil ??  0) }}</td>
                            <td class="text-end">{{ sumFormatWithoutCurrency(item.KaunterWakafPekanAmaun ??  0) }}</td>
                            <td class="text-end">{{ sumFormatWithoutCurrency(item.KaunterWakafRaubBil ??  0) }}</td>
                            <td class="text-end">{{ sumFormatWithoutCurrency(item.KaunterWakafRaubAmaun ??  0) }}</td>
                            <td class="text-end">{{ sumFormatWithoutCurrency(item.KaunterWakafTemerlohAmaun ??  0) }}</td>
                            <td class="text-end">{{ sumFormatWithoutCurrency(item.KaunterWakafTemerlohBil ??  0) }}</td>
                            <td class="text-end">{{ sumFormatWithoutCurrency(item.KaunterWakafRompinBil ??  0) }}</td>
                            <td class="text-end">{{ sumFormatWithoutCurrency(item.KaunterWakafRompinAmaun ??  0) }}</td>
                        </template>
                        <td class="text-end">{{ sumFormatWithoutDecimal(item.ServerResitDigitalBil)  }}</td>
                        <td class="text-end">{{ sumFormatWithoutCurrency(item.ServerResitDigitalAmaun)  }}</td>
                        <td class="table-dark fw-bold text-end">{{ sumFormatWithoutDecimal(item.TotalBil)  }}</td>
                        <td class="table-dark fw-bold text-end">{{ sumFormatWithoutCurrency(item.TotalAmaun)  }}</td>
                    </tr>
                    </tbody>
                    <tfoot>
                        <tr>
                            <td class="border-right-0"></td>
                            <td class="text-center fw-bold text-white">Jumlah</td>
                            <td v-for="(grandSumInQue,index) in reportData.bills" class="table-dark fw-bold text-end">{{ (index%2 === 0)? sumFormatWithoutDecimal(grandSumInQue) : sumFormatWithoutCurrency(grandSumInQue) }}</td>
                            <td class="table-dark fw-bold text-end">{{ sumFormatWithoutDecimal(reportData.grandSumBilTotal) }}</td>
                            <td class="table-dark fw-bold text-end">{{ sumFormatWithoutCurrency(reportData.grandSumAmaunTotal) }}</td>
                        </tr>
                    </tfoot>
                </table>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import {nextTick, onMounted, Ref, ref} from "vue";
import {arrayMonth, arrayYear, sumFormatWithoutCurrency, sumFormatWithoutDecimal, parseDateData} from "../../utils/utils";
import axios, {AxiosError} from "axios";
import Swal from "sweetalert2";
import { VueDatePicker } from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import { ms } from "date-fns/locale"
import { formatISO } from "date-fns"
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import {faChevronLeft, faFileExcel, faMagnifyingGlass} from "@fortawesome/free-solid-svg-icons";
library.add(faChevronLeft);
library.add(faFileExcel);
library.add(faMagnifyingGlass);

const data = defineProps<{
    uri_get_projek_kaunter: string,
    uri_download_report_projekwakaf_kaunter: string,
    month: number,
    year: number,
    csrf: string,
}>();

const type: Ref = ref<string>("bulan");
const yearRange: Ref = ref<number[]>();
const monthRange: Ref = ref<number[]>();
const dateFrom: Ref = ref<string|null>(null);
const dateTo: Ref = ref<string|null>(null);

const yearSelected: Ref = ref<number>();
const monthSelected: Ref = ref<number>();
const reportData: Ref = ref<{
    bills: number[],
    offices: string[],
    grandSumBilTotal: number,
    grandSumAmaunTotal: number,
    projekWakafKaunter: {
        project: string,
        BentongAmaun: number,
        BentongBil: number,
        BeraAmaun: number,
        BeraBil: number,
        IbuPejabatAmaun: number ,
        IbuPejabatBil: number,
        IbuPejabatWakafAmaun?: number,
        IbuPejabatWakafBil?: number,
        JengkaAmaun: number,
        JengkaBil: number,
        JerantutAmaun: number,
        JerantutBil: number,
        InderaMahkotaAmaun: number,
        InderaMahkotaBil: number,
        KualaLipisAmaun: number,
        KualaLipisBil: number,
        KuantanAmaun: number,
        KuantanBil: number,
        MaranAmaun: number,
        MaranBil: number,
        MuadzamShahAmaun: number,
        MuadzamShahBil: number,
        PekanAmaun: number,
        PekanBil: number,
        RaubAmaun: number,
        RaubBil: number,
        RompinAmaun: number,
        RompinBil: number,
        ServerResitDigitalAmaun: number,
        ServerResitDigitalBil: number,
        TemerlohAmaun: number,
        TemerlohBil: number,
        UnitKtrBergerak1Amaun: number,
        UnitKtrBergerak1Bil: number,
        UnitKtrBergerak2Amaun: number,
        UnitKtrBergerak2Bil: number,
        UtcKuantanAmaun: number,
        UtcKuantanBil: number,
        KaunterWakafBentongBil?: number,
        KaunterWakafBentongAmaun?: number,
        KaunterWakafBeraBil?: number,
        KaunterWakafBeraAmaun?: number,
        KaunterWakafCameronHighlandsBil?: number,
        KaunterWakafCameronHighlandsAmaun?: number,
        KaunterWakafChenorBil?: number,
        KaunterWakafChenorAmaun?: number,
        KaunterWakafJengkaBil?: number,
        KaunterWakafJengkaAmaun?: number,
        KaunterWakafJerantutBil?: number,
        KaunterWakafJerantutAmaun?: number,
        KaunterWakafKompleksAsnafBil?: number,
        KaunterWakafKompleksAsnafAmaun?: number,
        KaunterWakafKuantanBil?: number,
        KaunterWakafKuantanAmaun?: number,
        KaunterWakafLipisBil?: number,
        KaunterWakafLipisAmaun?: number,
        KaunterWakafMaranBil?: number,
        KaunterWakafMaranAmaun?: number,
        KaunterWakafMuadzamBil?: number,
        KaunterWakafMuadzamAmaun?: number,
        KaunterWakafPekanBil?: number,
        KaunterWakafPekanAmaun?: number,
        KaunterWakafRaubBil?: number,
        KaunterWakafRaubAmaun?: number,
        KaunterWakafTemerlohAmaun?: number,
        KaunterWakafTemerlohBil?: number,
        KaunterWakafRompinBil?: number,
        KaunterWakafRompinAmaun?: number
        TotalAmaun: number,
        TotalBil: number
    }[]
}>({
    bills : [0],
    offices: [""],
    grandSumBilTotal: 0,
    grandSumAmaunTotal: 0,
    projekWakafKaunter:[]
});
const wrapper: Ref = ref<HTMLDivElement>();
const olderOffice: Ref = ref<boolean>(false);
const offsetHeight: Ref = ref<number>(0);

const emitToParent = defineEmits<{
    (e: "hidePage", flag: boolean): void,
    (e: "hideLoader"): void,
    (e: "showLoader"): void,
}>();

onMounted(() => {
    setTimeout(()=> {
        yearRange.value = arrayYear(data.year);
        monthRange.value = arrayMonth();
        monthSelected.value = data.month;
        yearSelected.value = data.year;
        getData();
        if (wrapper.value) {
            wrapper.value.style.height = `calc(100svh - ${window.scrollY + wrapper.value?.getBoundingClientRect()?.top + 20}px)` ; //.getBoundingClientRect()?.top
        }
    },1000);
});

const getData = () => {
    emitToParent("showLoader");
    let postData: {
        csrf: string,
        month?: number,
        year?: number,
        from?: string,
        to?: string,
        wantOld?: number
    } = {
        csrf: data.csrf,
    };
    if (olderOffice.value === true) {
        postData = { ... postData, wantOld: 1} ;
    }
    if (type.value === "bulan") {
        postData = { ... postData, month: monthSelected.value};
        postData = { ... postData, year: yearSelected.value};
    } else if (type.value === "tarikh") {
        if (dateFrom.value !== null) {
            postData = { ... postData, from: formatISO(new Date(dateFrom.value))};
        }
        if (dateTo.value !== null) {
            postData = { ... postData, to: formatISO(new Date(dateTo.value))};
        }
    }
    axios({
        method: "post",
        url: data.uri_get_projek_kaunter,
        data: postData,
        headers: {"Content-Type": "application/json"}
    }).then(async (response) => {
        reportData.value = response.data;
        await nextTick(); //can be used immediately after a state change to wait for the DOM updates to complete
        offsetHeight.value = (document.getElementById("projekWakafKaunter") as HTMLTableElement).rows[1].offsetHeight;
        emitToParent("hideLoader");

    }).catch(function (error: AxiosError) {
        emitToParent("hideLoader");
        Swal.fire({
            icon: "error",
            title: "Ralat berlaku",
            text: "Sila cuba semula untuk cari. " + error.request.statusText,
            timer: 3000,
            timerProgressBar: true,
            confirmButtonColor: "#0d6efd",
            confirmButtonText: "Ok",
        })
    });
}

const goBack = () :void =>{
    emitToParent("hidePage", true);
}
</script>

<style scoped>
table {
    border-collapse: separate;
    border-spacing: 0;
}

.wrapper {
    overflow: auto;
}

table > thead > tr:nth-child(2) > th
{
    min-width: 150px;
    height: 70px;
}
.wrapper td {
    padding: 5px;
    width: 30px;
    min-width: 30px;
}


.wrapper :is(th:nth-child(1):not(:last-child),td:nth-child(1):not(:last-child)){
    position: sticky;
    left: 0;
}

.wrapper :is(th:nth-child(2):not(:last-child),td:nth-child(2):not(:last-child)){
    position: sticky;
    left: 30px;
}

.wrapper :is(td:nth-child(1):not(:last-child),td:nth-child(2):not(:last-child)){
    background-color: #5A1C50;
    border: 1px solid white;
}

tr:nth-child(1) > th:nth-child(4) /* Jumlah*/
{
    position: sticky;
    top: -10px;
    border: 1px solid black;
}

</style>
